module.exports = __webpack_public_path__ + "static/img/info8.52b4391.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/info8.jpg
// module id = f8tM
// module chunks = 1